import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const DEBUG = process.env.NODE_ENV !== 'production'
let module = 'form'
let modulePath = DEBUG ? '/' : `/${module}/`

const routes = [
  {
    path: '*',
    redirect: '/404',
  },
  {
    path: '/form/:accountid/:projectid/:channelid?/:code?',
    name: 'form',
    component: () => import('@/views/Attendee/index'),
    meta: {
      title: ' ',
    },
  },
  {
    path: '/result/:is_review/:accountid/:projectid/:dataid/:channelid?',
    name: 'result',
    component: () => import('@/views/result/index'),
    meta: {
      title: ' ',
    },
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/404/404'),
    meta: {
      title: ' ',
    },
  },
]

const router = new VueRouter({
  mode: 'history',
  // base: process.env.BASE_URL,
  base: modulePath,
  routes,
})

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router
